export default __webpack_public_path__ + "static/media/EDEN Crystals.e113a875.png";